<div class="layout-topbar">
    <div class="flex justify-content-between gap-5 logo-menu-icon">
        <a class="layout-topbar-logo" routerLink="">
            <span class="font-avenir primary-color">
            <img src="assets/images/XRack_Logo_W.svg" alt="Logo" width="100%" class="mr-2" style=" filter: invert(1);" />
            </span>
            <img src="assets/images/amazon-logo.png" alt="Logo" width="25%" class="mr-2" style="margin-left: 2rem; height: auto !important;" />
        </a>

        <button class="p-link layout-topbar-button p-trigger" (click)="layoutService.onMenuToggle()" style="margin-right: 7%;">
            <i class="pi pi-bars"></i>
        </button>
    </div>

    <div class="flex justify-content-end w-full">
        <app-warehouse-section-selector></app-warehouse-section-selector>
    </div>

    <div class="layout-topbar-menu">
        <p-menu [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" #menu [popup]="true" [model]="items"
            id="menuUser"></p-menu>
        <button class="p-link layout-topbar-button" (click)="menu.toggle($event)">
            <i class="pi pi-user"></i>
            <span>Profile</span>
        </button>
    </div>
</div>

<p-menu [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" #menu [popup]="true" [model]="items"
    id="menuUser"></p-menu>